import Collab from "../../Assets/Images/pm-services-icon/collab.svg";
import PR from "../../Assets/Images/pm-services-icon/pr.svg";
import Cost from "../../Assets/Images/pm-services-icon/cost_est.svg";
import Risk from "../../Assets/Images/pm-services-icon/risk.svg";
import Knowledge from "../../Assets/Images/pm-services-icon/knowledge.svg";
import Warranty from "../../Assets/Images/pm-services-icon/warranty.svg";
import Change from "../../Assets/Images/pm-services-icon/change_m.svg";
import Quality from "../../Assets/Images/pm-services-icon/quality.svg";
import React, { useEffect, useRef, useState } from "react";
import "./Offering-service.css";

const HowServicePage = () => {
  const listOfServices = [
    {
      img: Cost,
      title: "Business First Discovery",
      description:
        "We start by getting to know how decisions are made, where work slows down and what is frustrating your team right now. This process of discovery defines custom-built software that fits reality, not assumptions.",
    },
    {
      img: PR,
      title: "Offshore Teams That Stay Put",
      description:
        "Our offshore software development teams in Bangladesh are stable and long-term. The same people learn your product on a very deep level, which eliminates risks of rework, miscommunication and dependency on time.",
    },
    {
      img: Collab,
      title: "Architecture Built-to-Cause Change",
      description:
        "Change is what we anticipate when we design software architecture. New features, new users and new integrations are all planned for from the beginning, so there are no painful rebuilds later on as your custom software scales.",
    },
    {
      img: Change,
      title: "Clear Communication Through Design",
      description:
        "We organise communication on purpose. Clear ownership, predictable updates and direct access to the team guarantee that offshore custom software development is never distant or disconnected.",
    },
    {
      img: Risk,
      title: "Real World UX Decisions",
      description:
        "Design choices are based on observing the actual use of systems under pressure. We create interfaces that eliminate clicks, errors, and training time in actual workflows.",
    },
    {
      img: Quality,
      title: "Quality Woven Into Delivery",
      description:
        "Testing occurs continuously, and not at the end. Our process catches issues early on, protects timelines and ensures custom software behaves reliably in live business environments.",
    },
    {
      img: Knowledge,
      title: "Security And Responsibility Built In",
      description:
        "From access control to data handling, we develop custom software with confidentiality and due diligence in mind. Trust, security, and compliance are treated as defaults, not extras.",
    },
    {
      img: Warranty,
      title: "Support Beyond Go Live",
      description:
        "Launch is not the finish line. We stick with it after release, enhancing performance, refining features, and assisting in growth as your software becomes central to operations.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const rowRef = useRef(null);
  const progressRef = useRef(null);

  useEffect(() => {
    const row = rowRef.current;
    const progress = progressRef.current;
    if (!row || !progress || listOfServices.length === 0) return;

    // Update progress bar
    const percent = ((activeIndex + 1) / listOfServices.length) * 100;
    progress.style.transition = "width 0.4s ease";
    progress.style.width = `${percent}%`;

    if (window.innerWidth < 1024) {
      // Mobile: scroll to active card
      const activeCard = row.children[activeIndex];
      if (activeCard) {
        activeCard.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }
    } else {
      // Desktop: calculate transform shift to prevent empty space at the end
      const cardWidth = row.children[0]?.offsetWidth + 30 || 0;
      const visibleCards = Math.floor(row.offsetWidth / cardWidth);
      const maxOffset = (listOfServices.length - visibleCards) * cardWidth;
      const rawOffset = (activeIndex - 1) * cardWidth;
      const offset = Math.max(0, Math.min(rawOffset, maxOffset));

      row.style.transition = "transform 0.5s ease";
      row.style.transform = `translateX(-${offset}px)`;
    }
  }, [activeIndex, listOfServices.length]);

  return (
    <div id="how-manage" className="offering-service-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="top-contents">
              <h1 className="service-headline1">
                What Makes Our Custom Software Development Different
              </h1>
              <p className="service-text1">
                Good custom software is the solution to a business need. Great
                custom software helps change the way work actually happens
                inside your company. We don’t just deliver code. We work with
                you to understand your unique workflows and find hidden
                bottlenecks and build software that doesn't just work, but feels
                like it was built just for your business. Our offshore custom
                development allows you to access global talent and shorten time
                to market while staying very close to your goals.
              </p>
            </div>

            <div className="middle-contents">
              <div className="carousel-wrapper">
                <div className="service-row" ref={rowRef}>
                  {listOfServices.map((service, i) => (
                    <div
                      key={i}
                      className={`service-card ${
                        i === activeIndex ? "active" : ""
                      }`}
                      onClick={() => setActiveIndex(i)}
                    >
                      <div className="service-icons">
                        <img src={service.img} alt={service.title} width={60} />
                      </div>
                      <h2 className="service-project-title">{service.title}</h2>
                      <p className="service-project-description">
                        {service.description}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="end-contents">
              <div className="progress-container">
                <div className="progress-bar" ref={progressRef}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowServicePage;
